import { Component, OnInit } from '@angular/core'

import { CONTACT_LINK_CLASSNAME } from 'src/constants/gtmSelectors'

import LocalStorageService from '../../core/local-storage.service'
import Booking from '../../core/models/booking'
import Country from '../../core/models/country'
import ThemeService from '../../core/themes.service'
import TranslateService from '../../core/translate.service'


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export default class FooterComponent implements OnInit {
  booking: Booking
  themeName = ''
  phoneNumber = ''
  country : Country;

  contactBlocks = []
  socialMediaBlocks = []
  contactInformation = []

  contactLinkClassName = CONTACT_LINK_CLASSNAME

  constructor(
    private themeService: ThemeService,
    private localStorageService: LocalStorageService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.country = this.localStorageService.getCurrentCountry()

    this.translate.useLanguage(this.localStorageService.getLocale()).then(() => {
      this.updateInformation()
    })
  }

  updateInformation(): void {
    if (this.localStorageService.getThemeName()) {
      this.themeService.setTheme(this.localStorageService.getThemeName())
    }
    this.checkAndUpdateLocalPhoneNumber()
    this.themeName = this.themeService.getThemeName()
    this.phoneNumber = this.translate.getTranslation('footer-customer-support-phone-number')
    this.socialMediaBlocks = this.translate.getTranslationArray('footer-social-media-blocks')
    this.contactBlocks = this.translate.getTranslationArray('footer-contact-blocks')
    this.contactInformation = this.translate.getTranslationArray('footer-contact-information')

  }
   checkAndUpdateLocalPhoneNumber(): void {
    if(this.country !== Country.Norway && this.country !== Country.Finland){
      return
    }
    this.booking = this.localStorageService.getBooking();
    if(!this.booking){
      return
    }
    this.phoneNumber = `${this.booking?.pickupPlace?.phoneNumber}`
    if(this.phoneNumber.length > 0){
      this.translate.updateNumberForFooter(this.phoneNumber)
    }
  }
}
